<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- DIVIDERS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              DIVIDERS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <p>Çoğu zaman altlarında bulunan kart, kutunun veya alanın içeriğini tanımlamak için kullanılan, bazısı ikincil bir bilgi alanı ve ikon da içeren yapılardır.</p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <h2>
                  Style 1
                </h2>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-4">
                <div class="divider bold">
                  <p class="content">
                    <i />
                    CONTENT
                  </p>
                  <p class="second-content">
                    Second Content
                  </p>
                </div>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-6">
                <div class="divider bold">
                  <p class="content">
                    <i />
                    CONTENT
                  </p>
                  <p class="second-content">
                    Second Content
                  </p>
                </div>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-8">
                <div class="divider bold">
                  <p class="content">
                    <i />
                    CONTENT
                  </p>
                  <p class="second-content">
                    Second Content
                  </p>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <h2>
                  Style 2
                </h2>
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="col-4">
                <div class="divider with-line">
                  <p class="content bold">
                    <span class="xxs">BAŞVURU TARİHİ: DÜN</span>
                  </p>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-6">
                <div class="divider with-line">
                  <p class="content bold">
                    <span class="xxs">BAŞVURU TARİHİ: DÜN</span>
                  </p>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-8">
                <div class="divider with-line">
                  <p class="content bold">
                    <span class="xxs">BAŞVURU TARİHİ: DÜN</span>
                  </p>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Divider',
  data() {
    return {};
  },
  computed: {},
};
</script>
